/* eslint-disable */
import * as util from "@/api/messageReport";

const state = {};


const mutations = {
};

const actions = {
    listSmartReplyDetailMonthly({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listSmartReplyDetailMonthly(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listSmartReplysMonthly({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listSmartReplysMonthly(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listButtonsDetailMonthly({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listButtonsDetailMonthly(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listButtonsMonthly({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listButtonsMonthly(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listBroadcast({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listBroadcast(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listMessage({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listMessage(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/messageReport.js